import React from "react";
import "./AgentAgencyApprovalWaiting.scss";
import { useNavigate } from "react-router-dom";
import { LocalStorageHelpers } from "../../../utils/helpers/localstorage.helpers";
import { clientRoutes } from "../../../utils/routes";
import ProfileImage from "../../dashboard/profileImage/ProfileImage";

const AgentAgencyApprovalWaiting = () => {
  const navigate = useNavigate();

  const agentData = LocalStorageHelpers.getAgentData();

  const agentName = `${agentData?.principal_agent_first_name || ""} ${
    agentData?.principal_agent_last_name || ""
  }`;

  const handleLogout = () => {
    LocalStorageHelpers.clear();
    navigate(clientRoutes.login);
  };

  return (
    <div className="agent-waiting-wrapper">
      <div className="header-logo">
        <img src="/images/logos/brand-bards-logo-2x.png" alt="Brand Bards" />
      </div>

      <div className="waiting-card">
        <div className="profile-section">
          <ProfileImage
            uploadRecord={agentData?.profile_image_ref}
            url={agentData?.profile_image}
            width={100}
            height={100}
          />
        </div>

        <h2 className="welcome-text">Welcome, {agentName}</h2>

        <div className="icon-section">
          <div className="icon-bg">
            <img src="/images/pendingicon.svg" alt="Pending" />
          </div>
        </div>

        <h3 className="title">Your agency registration is under review</h3>

        <p className="description">
          We’re currently reviewing your joining request.
          <br />
          We'll notify you via email as soon as your account is approved.
        </p>

        <button className="logout-btn" onClick={handleLogout}>
          Logout
        </button>
      </div>
    </div>
  );
};

export default AgentAgencyApprovalWaiting;
